import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NzModalService} from 'ng-zorro-antd/modal';
import { ManageComponent } from 'src/app/shared/components/manage.component';
import { ProductService } from 'src/app/modules/product/product.service';
import { AccountService, EventManager } from 'src/app/core';

@Component({
  selector: 'app-products-list',
  templateUrl: './products-list.component.html',
  styleUrls: ['./products-list.component.scss']
})
export class ProductsListComponent extends ManageComponent implements OnInit, OnDestroy {
  list?: any[];
  searchParams: any = {};
  type: any;
  title: any;
  constructor(
    protected productService: ProductService,
    protected activatedRoute: ActivatedRoute,
    private accountService: AccountService,
    protected router: Router,
    public modalService: NzModalService,
    public eventManager: EventManager
  ) {
    super(eventManager, modalService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.activatedRoute.params.subscribe((params) => {
      this.type = (params.type || '').toLowerCase();
      switch (this.type) {
        case 'fund':
          this.title = 'Chứng chỉ quỹ';
        break;
        case 'sip':
          this.title = 'SIP';
        break;
        case 'bond':
          this.title = 'Trái phiếu';
        break;
        case 'certificate':
          this.title = 'Chứng chỉ tiền gửi';
        break;
        case 'bond-issuer':
          this.title = 'Đơn vị phát hành trái phiếu';
        break;
        case 'dividend':
          this.title = 'Cổ tức';
        break;
      }
      this.executeCallAPI();
    });
  }

  loadAll(req?: any) {
    this.queryParams.searchParams.statusId = [6, 7, 9];
    req = req || this.queryParams;
    this.list = [];
    this.productService
      .queryByType(this.type, req)
      .subscribe(this.onResponse.bind(this));
  }

  confirmDelete(id: number) {
    this.productService.deactivate(id).subscribe(rs => {
      this.executeCallAPI();
    });
  }
}
